import { cn } from "@heroui/react";

const Tag = ({
    children,
    color = "default",
    size = "md",
    variant = "flat", // flat, solid, bordered, faint
    radius = "full", // none, sm, md, lg, full
    className,
}) => {
    const sizes = {
        sm: "px-1.5 py-0.5 text-[10px]",
        md: "px-2.5 py-0.5 text-xs",
        lg: "px-3 py-1 text-sm",
    };

    const radii = {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded-md",
        lg: "rounded-lg",
        full: "rounded-full",
    };

    const variants = {
        flat: {
            default:
                "bg-zinc-100 text-zinc-500 dark:bg-zinc-800 dark:text-zinc-400",
            primary:
                "bg-primary-50 text-primary-600 dark:bg-primary-900/20 dark:text-primary-400",
            success:
                "bg-emerald-50 text-emerald-600 dark:bg-emerald-900/20 dark:text-emerald-400",
            danger: "bg-rose-50 text-rose-600 dark:bg-rose-900/20 dark:text-rose-400",
            warning:
                "bg-amber-50 text-amber-600 dark:bg-amber-900/20 dark:text-amber-400",
            info: "bg-blue-50 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400",
        },
        solid: {
            default: "bg-zinc-500 text-white dark:bg-zinc-600",
            primary: "bg-primary-500 text-white",
            success: "bg-emerald-500 text-white",
            danger: "bg-rose-500 text-white",
            warning: "bg-amber-500 text-white",
            info: "bg-blue-500 text-white",
        },
        bordered: {
            default:
                "border border-zinc-200 text-zinc-500 dark:border-zinc-700 dark:text-zinc-400 bg-transparent",
            primary:
                "border border-primary-200 text-primary-600 dark:border-primary-800 dark:text-primary-400 bg-transparent",
            success:
                "border border-emerald-200 text-emerald-600 dark:border-emerald-800 dark:text-emerald-400 bg-transparent",
            danger: "border border-rose-200 text-rose-600 dark:border-rose-800 dark:text-rose-400 bg-transparent",
            warning:
                "border border-amber-200 text-amber-600 dark:border-amber-800 dark:text-amber-400 bg-transparent",
            info: "border border-blue-200 text-blue-600 dark:border-blue-800 dark:text-blue-400 bg-transparent",
        },
        faint: {
            default: "text-zinc-500 dark:text-zinc-400 bg-transparent",
            primary: "text-primary-600 dark:text-primary-400 bg-transparent",
            success: "text-emerald-600 dark:text-emerald-400 bg-transparent",
            danger: "text-rose-600 dark:text-rose-400 bg-transparent",
            warning: "text-amber-600 dark:text-amber-400 bg-transparent",
            info: "text-blue-600 dark:text-blue-400 bg-transparent",
        },
    };

    const variantStyles = variants[variant] || variants.flat;
    const colorStyle = variantStyles[color] || variantStyles.default;

    return (
        <div
            className={cn(
                "inline-flex items-center justify-center font-medium whitespace-nowrap transition-colors",
                sizes[size],
                radii[radius],
                colorStyle,
                className,
            )}
        >
            {children}
        </div>
    );
};

export default Tag;
